import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import './App.css';
import Footer from './components/default-components/Footer';
import Header from './components/default-components/Header';
import Home from './components/default-components/Home';
import SideNav from './components/default-components/SideNav';
import Charts from './components/pages/charts/Charts';
import Widgets from './components/pages/Screens/Widgets';
import Calendar from './components/pages/Screens/Calendar';
import Gallery from './components/pages/Screens/Gallery';
import Kanban from './components/pages/Screens/Kanban';
import Flot from './components/pages/charts/Flot';
import Inline from './components/pages/charts/Inline';
import Uplot from './components/pages/charts/Uplot';
import ContactUs from './components/pages/Screens/ContactUs';
import Contacts from './components/pages/Screens/Contacts';
import Ecommerce from './components/pages/Screens/Ecommerce';
import Faq from './components/pages/Screens/Faq';
import ForgotPassword from './components/pages/Screens/ForgotPassword';
import Invoice from './components/pages/Screens/Invoice';
import InvoicePrint from './components/pages/Screens/InvoicePrint';
import LockScreen from './components/pages/Screens/LockScreen';
import Login from './components/pages/Screens/Login';
import Profile from './components/pages/Screens/Profile';
import ProjectAdd from './components/pages/Screens/ProjectAdd';
import ProjectDetail from './components/pages/Screens/ProjectDetail';
import ProjectEdit from './components/pages/Screens/ProjectEdit';
import ChangePassword from './components/pages/Screens/ChangePassword';
import Projects from './components/pages/Screens/Projects';
import Register from './components/pages/Screens/Register';
import Mailbox from './components/pages/mailbox/Mailbox';
import MailCompose from './components/pages/mailbox/MailCompose';
import MailRead from './components/pages/mailbox/MailRead';
import SearchResults from './components/pages/Screens/SearchResults';
import JsGrid from './components/pages/tables/JsGrid';
import Simple from './components/pages/tables/Simple';
import Datas from './components/pages/tables/Datas';
import SplashScreen from './components/pages/Screens/SplashScreen';
import SideChat from './components/pages/Screens/SideChat';
import Chat from './components/pages/Chat';
import ScrollToTopOnMount from './components/pages/Screens/ScrollToTopOnMount';



const DefaultLayout = ({ children }) => (
  <>
   <SideChat/>
    <Header />
   
    <SideNav />
    <Outlet />
    <Footer />
    
  </>
);

const App = () => (
  <div className='wrapper'>
  <Router>
  <ScrollToTopOnMount/>
  <Routes>
  <Route path="/" element={<SplashScreen />} />
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    
    
    <Route
        element={<DefaultLayout />}
      >
        <Route path="/dashboard" element={<Home />} />
        <Route path="/widgets" element={<Widgets />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/kanban" element={<Kanban />} />
        <Route path="/charts" element={<Charts />} />
        <Route path="/flot" element={<Flot />} />
        <Route path="/inline" element={<Inline />} />
        <Route path="/uplot" element={<Uplot />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/e-commerce" element={<Ecommerce />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/invoice" element={<Invoice />} />
        <Route path="/invoice-print" element={<InvoicePrint />} />
        <Route path="/lockScreen" element={<LockScreen />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/project-add" element={<ProjectAdd />} />
        <Route path="/project-detail" element={<ProjectDetail />} />
        <Route path="/project-edit" element={<ProjectEdit />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/mailbox" element={<Mailbox />} />
        <Route path="/mail-compose" element={<MailCompose />} />
        <Route path="/mail-read" element={<MailRead />} />
        <Route path="/Search-results" element={<SearchResults />} />
        <Route path="/table-datas" element={<Datas />} />
        <Route path="/table-jsgrid" element={<JsGrid />} />
        <Route path="/table-simple" element={<Simple />} />
        <Route path="/chat" element={<Chat />} />
      </Route>

  </Routes>
</Router>
</div>
);

export default App;
